import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailSynopsisContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  margin-top: ${32 * Screen.widthRatio}px;
  height: ${160 * Screen.widthRatio}px;
  width: ${883 * Screen.widthRatio}px;
  overflow: hidden;
`;

export default DetailSynopsisContainer;
